import { SxProps, Theme } from "@mui/material/styles";
import theme from "../../../../theme";

const styles: SxProps<Theme> = [
  {
    "&.container": {
      width: "100%",
      background: theme.palette.primary.main,
      padding: "8px",
      textAlign: "center",
      "& p": {
        fontSize: 20,
        color: "#FFF",
        margin: "auto",
        maxWidth: 392,
      },
    },

    "@media all and (max-width: 580px)": {
      container: {
        "& img": {
          width: 280,
        },
      },
    },
  },
];
export default styles;
